<template>
    <button :disabled="buttonDisabled">
        <slot />
    </button>
</template>

<script lang="ts" setup>
const {disabled = false} = defineProps<{
    disabled?: boolean
}>()

const fieldsManagement = useFieldManagement()

const buttonDisabled = computed(() => {
    return !!(fieldsManagement.fieldsDisabled?.value || disabled)
})
</script>